import React, {useState, useEffect} from 'react';
import { Link, useLocation, useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import axios from 'axios';
import './market.css';
import {he} from './store';
import { isMobile } from 'react-device-detect';


const Find=()=>{
    const histo = useNavigate();
    const seonta = useLocation();
    const [ori, setori] = useState(false);


let code;
const createCaptcha=()=>{
  //clear the contents of captcha div first 
  document.getElementById('captcha').innerHTML = "";
  const charsArray =
  "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lengthOtp = 6;
  const captcha = [];
  for (let i = 0; i < lengthOtp; i++) {
    //below code will not allow Repetition of Characters
    const index = Math.floor(Math.random() * charsArray.length + 1); //get the next character from the array
    if (captcha.indexOf(charsArray[index]) == -1)
      captcha.push(charsArray[index]);
    else i--;
  }
  const canv = document.createElement("canvas");
  canv.id = "captcha";
  canv.width = 100;
  canv.height = 50;
  const ctx = canv.getContext("2d");
  ctx.font = "25px Georgia";
  ctx.strokeText(captcha.join(""), 0, 30);
  //storing captcha so that can validate you can save it somewhere else according to your specific requirements
  code = captcha.join("");
  document.getElementById("captcha").appendChild(canv); // adds the canvas to the body element
};

const validateCaptcha= async (e)=>{
  e.preventDefault();
 
  
  if (e.target.code.value == code) {
   const huida = await axios.post('/api/member',{email : e.target.mail.value, mingzi : e.target.mingzi.value, seon : seonta.state }).then(chae=>{
  if(!chae.data){alert("이메일 주소 확인이 필요합니다");  createCaptcha();}else{alert("메일 확인 바랍니다");  createCaptcha();}}).catch(e=>{
    
    if(e.response?.data?.condition === "emailerror"){
      alert("이메일 주소 확인이 필요합니다");  createCaptcha();
    };
    if(e.response?.data?.condition === "nameerror"){
      alert("이름 확인이 필요합니다");  createCaptcha();
    };
    if(e.response?.data?.condition === "membernot"){
      alert("회원 유형을 선택해주세요");  createCaptcha();
    };
  });
  }else{
    alert("Invalid Captcha. try Again");
    createCaptcha();
  }
};


const kana =async (e)=>{
  e.preventDefault();
 const kona = await axios.get('/api/upkin')
 .then(dada=>{console.log("");}).catch(a=>console.log("여기가 나와",a));};

    useEffect(()=>{
      createCaptcha();
    },[]);
    
    document.title = "아이디·비번 찾기 - 돌파공모";

    return(
    <>
    <h3>아이디 &middot; 비번 찾기</h3>
    <div className={isMobile ? 'kugi' : ''}>
        <form className={isMobile ? 'mjofo' : 'jofo'} onSubmit={validateCaptcha}>
            <h3><label for="mail">이메일</label></h3>  
            <span className='j1'>
                <input type='email' placeholder='가입 시 기재한 이메일' name='mail' pattern="^[a-zA-Z0-9!$&*.=^`|~#%'+\/?_{}-]+@([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,4}$" required/>
            </span>
            <h3><label for="mingzi">이름</label></h3>  
            <span className='j1'>
              <input type='text' placeholder='이름' name='mingzi' required/>
            </span>
            <h3><label for="code">확인코드</label></h3>  
            <span className='j1'>
                <input type='text' name='code' placeholder='아래 확인코드 입력' required />
            </span>
            <span className='j2'>
            <div id='captcha'></div> <div className='cpa2'><span onClick={createCaptcha} className='cpa4'><img src={process.env.PUBLIC_URL+`/revision.png`} className='cpa3' /></span></div>
            </span>
            {/* <span onClick={createCaptcha}>RE</span> */}
           {ori && <p>아이디 또는 비밀번호를 확인해주세요</p>}
           <button onSubmit={validateCaptcha}> 확인</button>
        </form>
    </div>
    </>
    );
    }
    
    export default Find;